import { typeBrand } from "./brand"
import { queryBrands } from "./queries/queryBrands"

const brandSchema = {
  types: [typeBrand],
  resolvers: {
    Query: {
      ...queryBrands,
    },
    Mutation: {},
  },
}

export default brandSchema
